export default "__VITE_ASSET__2diOO_BD__"